// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"VirtualTable-tableContainer-2W_Um"};